import { Alert, Button, Col, Modal, Row } from 'react-bootstrap'
import { ISwapQualityIssueForList } from '@nkr/models/index';

interface IProps {
    show: boolean,
    data: ISwapQualityIssueForList,
    onConfirm: () => void,
    onCancel: () => void
}

const ConfirmReopen = (props: IProps) => {
    if (props.data == null) {
        return null;
    }

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Confirm Reopening Swap Quality Issue
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' bsSize='sm'>Please confirm that you would like to reopen the following swap quality issue report:</Alert>

                <div className='container-fluid'>
                    <Row>
                        <Col xs={12} lg={3}>Swap:</Col>
                        <Col xs={12} lg={9}>{props.data.swapInfo}</Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={3}>Donor Center:</Col>
                        <Col xs={12} lg={3}>{props.data.donorCenter}</Col>
                        <Col xs={12} lg={3}>Recipient Center:</Col>
                        <Col xs={12} lg={3}>{props.data.recipientCenter}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={3}>Donor Alias:</Col>
                        <Col xs={12} lg={3}>{props.data.donorAlias}</Col>
                        <Col xs={12} lg={3}>Recipient Alias:</Col>
                        <Col xs={12} lg={3}>{props.data.recipientAlias}</Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirmed</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmReopen;